import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  FormHelperText,
  IconButton,
  Slide,
  Tooltip,
  Badge,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import { DropzoneArea } from "material-ui-dropzone";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { TrainingRepository } from "./TrainingRepository";
import GradingCommentComponent from "./GradingCommentComponent";
import {
  trainingDataValidator,
  trainingDataPointsValidator,
} from "./TrainingDataValidator";
import Upload from "../../../common/components/Upload";
import "../../../App.css";
import { LOCALE } from "../../../properties/Locale";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useState } from "react";

const useStyles = makeStyles(styles);

export default function TrainingComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [rerender, triggerRerender] = React.useState(false);
  const [files, setFiles] = React.useState();
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [trainingRoles, setTrainingRoles] = React.useState();
  const [trainingOrganizers, setTrainingOrganizers] = React.useState();
  const [trainingHourRanges, setTrainingHourRanges] = React.useState();
  const [trainingDataFormErrors, setTrainingDataFormErrors] = React.useState(
    {}
  );
  const [trainingData, setTrainingData] = React.useState([]);
  const [showCommentDialog, setShowCommentDialog] = React.useState(false);
  const [commentItem, setCommentItem] = React.useState();
  const [commentIndex, setCommentIndex] = React.useState();
  const [trainingRoleOptions, setTrainingRoleOptions] = useState([]);
  const [loadingTrainingData, setLoadingTrainingData] = useState(false);

  useEffect(() => {
    triggerRerender(!rerender);
  }, [trainingDataFormErrors]);

  useEffect(() => {
    TrainingRepository.getAllRoles(
      props.gradingSchemaId,
      trainingData.organizer?.id
    ).then(
      (res) => {
        setTrainingRoles(res.data);
      },
      (err) => {}
    );
    TrainingRepository.getAllOrganizers(props.gradingSchemaId).then(
      (res) => {
        setTrainingOrganizers(res.data);
      },
      (err) => {}
    );
    TrainingRepository.getAllHourRanges(props.gradingSchemaId).then(
      (res) => {
        setTrainingHourRanges(res.data);
      },
      (err) => {}
    );
    setLoadingTrainingData(true);
    TrainingRepository.getTrainingData(props.vacancyAppId)
      .then(
        async (res) => {
          if (res.data.length > 0) {
            const data = res.data;
            setTrainingData(data);

            const roleOptions = [];
            const organizerRoleCache = {};

            for (let i = 0; i < data.length; i++) {
              const organizerId = data[i]?.organizer?.id;
              if (organizerId) {
                if (!organizerRoleCache[organizerId]) {
                  try {
                    const roleRes = await TrainingRepository.getAllRoles(
                      props.gradingSchemaId,
                      organizerId
                    );
                    organizerRoleCache[organizerId] = roleRes.data;
                  } catch (e) {
                    organizerRoleCache[organizerId] = [];
                  }
                }
                roleOptions[i] = organizerRoleCache[organizerId];
              } else {
                roleOptions[i] = [];
              }
            }

            setTrainingRoleOptions(roleOptions);
            triggerRerender((prev) => !prev);
          }
        },
        (err) => {}
      )
      .finally(() => {
        setLoadingTrainingData(false);
      });
  }, []);

  const addRow = () => {
    let data = trainingData;
    data.push({
      name: "",
      organizer: { id: "" },
      hourRange: { id: "" },
      date: new Date(),
      role: { id: "" },
      proofs: undefined,
    });
    setTrainingData(data);
    setTrainingDataFormErrors({});
    triggerRerender(!rerender);
  };

  const deleteRow = (index) => {
    let data = trainingData;
    data.splice(index, 1);
    setTrainingData(data);
    setTrainingDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = async (event, index, name) => {
    let data = trainingData;
    if (name === "organizer") {
      const organizerId = event.target.value;
      data[index].organizer.id = organizerId;

      data[index].role = { id: "" };

      try {
        const res = await TrainingRepository.getAllRoles(
          props.gradingSchemaId,
          organizerId
        );
        const updatedRoleOptions = [...trainingRoleOptions];
        updatedRoleOptions[index] = res.data;
        setTrainingRoleOptions(updatedRoleOptions);
      } catch (err) {
        console.error("Failed to fetch roles", err);
      }
    } else if (name === "hourRange" || name === "role") {
      data[index][name].id = event.target.value;
    } else {
      data[index][name] = event.target.value;
    }
    setTrainingData(data);
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, index, name) => {
    let data = trainingData;
    data[index][name] = date;
    setTrainingData(data);
    triggerRerender(!rerender);
  };

  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = trainingData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!trainingDataValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await trainingDataValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setTrainingDataFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = trainingData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!trainingDataValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await trainingDataValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setTrainingDataFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    TrainingRepository.saveTrainingData(props.vacancyAppId, trainingData).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = trainingData;
    data[index].proofs = attachments;
    setTrainingData(data);
  };

  const changePoints = (item) => {
    TrainingRepository.updatePoints(item.id, item.points).then((res) => {
      TrainingRepository.getTrainingData(props.vacancyAppId).then(
        (res) => {
          if (res.data.length > 0) {
            setTrainingData(res.data);
            setTrainingDataFormErrors({});
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const unlockPoints = (item) => {
    TrainingRepository.unlockPoints(item.id).then((res) => {
      TrainingRepository.getTrainingData(props.vacancyAppId).then(
        (res) => {
          if (res.data.length > 0) {
            setTrainingData(res.data);
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const evaluationNextStep = (data) => {
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!trainingDataPointsValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      props.handleEvaluationNextStep(data, "training");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await trainingDataPointsValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setTrainingDataFormErrors(validationErrors);
    }
  };

  const openCommentDialog = (item, index) => {
    setCommentItem(item);
    setCommentIndex(index);
    setShowCommentDialog(true);
  };

  const closeCommentDialog = (item, index) => {
    if (item != undefined) {
      TrainingRepository.setComment(item.id, item.comment).then((res) => {
        let tmp = trainingData;
        tmp[index] = item;
        setTrainingData(tmp);
        triggerRerender(!rerender);
        setShowCommentDialog(false);
      });
    } else {
      setShowCommentDialog(false);
    }
  };

  return (
    <div>
      {!props.disabled && (
        <Alert
          style={{ marginBottom: "45px", marginTop: "10px" }}
          fullwidth="true"
          severity="info"
        >
          <AlertTitle> {LOCALE.training_info_title}</AlertTitle>
          {LOCALE.training_info_description}
        </Alert>
      )}

      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={4}>
              {" "}
              <Typography>
                {LOCALE.list_of_proofs_for_professional_development},{" "}
                {LOCALE.domain} {LOCALE.trainings}
              </Typography>
            </Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={2}>
              {!props.disabled && (
                <div>
                  <Button
                    className={trainingData.length === 0 ? "bounceButton" : ""}
                    color="default"
                    variant="contained"
                    startIcon={<Icon>add_circle_outline</Icon>}
                    size="small"
                    aria-label="create"
                    style={{ float: "right" }}
                    onClick={addRow}
                  >
                    {LOCALE.add_training}
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="trainings table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.num}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.training_name}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.training_organizer}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.training_hour_range}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.date}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.training_role}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.proof}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {trainingData.length > 0 ? (
                trainingData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.name}
                          variant="outlined"
                          label={LOCALE.training_name}
                          size="small"
                          error={trainingDataFormErrors[index]?.name}
                          helperText={
                            trainingDataFormErrors[index]?.name?.message
                          }
                          onChange={(e) => handleChange(e, index, "name")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.organizer.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          error={
                            trainingDataFormErrors[index] &&
                            trainingDataFormErrors[index]["organizer.id"]
                          }
                          variant="outlined"
                          size="small"
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.training_organizer}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.training_organizer}
                            value={item.organizer.id}
                            onChange={(e) =>
                              handleChange(e, index, "organizer")
                            }
                          >
                            {trainingOrganizers?.map((item, index) => (
                              <MenuItem
                                key={index}
                                value={item.id}
                                style={{ whiteSpace: "normal", maxWidth: 500 }}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {trainingDataFormErrors[index] &&
                              trainingDataFormErrors[index]["organizer.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.hourRange.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          error={
                            trainingDataFormErrors[index] &&
                            trainingDataFormErrors[index]["hourRange.id"]
                          }
                          variant="outlined"
                          size="small"
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.training_hour_range}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.training_hour_range}
                            value={item.hourRange.id}
                            onChange={(e) =>
                              handleChange(e, index, "hourRange")
                            }
                          >
                            {trainingHourRanges?.map((item, index) => (
                              <MenuItem
                                key={index}
                                value={item.id}
                                style={{ whiteSpace: "normal", maxWidth: 500 }}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {trainingDataFormErrors[index] &&
                              trainingDataFormErrors[index]["hourRange.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        disabled={props.disabled}
                        fullWidth
                        style={{ marginTop: -15 }}
                      >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disabled={props.disabled}
                            disableToolbar
                            variant="outlined"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="date-from"
                            label={LOCALE.date}
                            value={item.date}
                            onChange={(date) =>
                              handleChangeDate(date, index, "date")
                            }
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.role.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled || !item.organizer.id}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          variant="outlined"
                          error={
                            trainingDataFormErrors[index] &&
                            trainingDataFormErrors[index]["role.id"]
                          }
                          size="small"
                        >
                          <InputLabel id={`role-select-label-${index}`}>
                            {LOCALE.role}
                          </InputLabel>
                          <Select
                            labelId={`role-select-label-${index}`}
                            id={`role-select-${index}`}
                            label={LOCALE.role}
                            value={item.role.id}
                            onChange={(e) => handleChange(e, index, "role")}
                          >
                            {(trainingRoleOptions[index] || []).map(
                              (role, idx) => (
                                <MenuItem
                                  key={idx}
                                  value={role.id}
                                  style={{
                                    whiteSpace: "normal",
                                    maxWidth: 500,
                                  }}
                                >
                                  {role.name}
                                </MenuItem>
                              )
                            )}
                          </Select>
                          <FormHelperText>
                            {trainingDataFormErrors[index] &&
                              trainingDataFormErrors[index]["role.id"]?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          trainingDataFormErrors[index] &&
                          trainingDataFormErrors[index]["proofs"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"TRAINING"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.proofs}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {trainingDataFormErrors[index] &&
                            trainingDataFormErrors[index]["proofs"]?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    {props.showPoints && (
                      <React.Fragment>
                        <TableCell className={classes.tableCell}>
                          <TextField
                            disabled={true}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                          />
                        </TableCell>
                      </React.Fragment>
                    )}
                    {!props.disabled && (
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          disabled={props.disabled}
                          color="secondary"
                          size="small"
                          style={{ marginTop: "6px" }}
                          aria-label="delete"
                          onClick={() => deleteRow(index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                        {/* {props.status === "ADDITIONAL_DATA_REQUIRED" && (
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                        )} */}
                      </TableCell>
                    )}
                    {props.evaluation && (
                      <TableCell className={classes.tableCell} width={150}>
                        <FormControl
                          style={{ display: "inline" }}
                          error={
                            trainingDataFormErrors[index] &&
                            trainingDataFormErrors[index]["pointsChecked"]
                          }
                        >
                          <TextField
                            disabled={item.pointsChecked}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                            onChange={(e) => handleChange(e, index, "points")}
                          />
                          {!item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.confirm_points}
                              aria-label={LOCALE.confirm_points}
                            >
                              <IconButton
                                style={{ color: "green", top: "6px" }}
                                size="small"
                                onClick={() => changePoints(item)}
                              >
                                <Icon>check</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          {item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.change_points}
                              aria-label={LOCALE.change_points}
                            >
                              <IconButton
                                style={{ color: "red", top: "6px" }}
                                size="small"
                                onClick={() => unlockPoints(item)}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                style={{ top: "6px" }}
                                size="small"
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                          <FormHelperText id="municipality-helper-text">
                            {trainingDataFormErrors[index] &&
                              trainingDataFormErrors[index]["pointsChecked"]
                                ?.message}
                          </FormHelperText>{" "}
                        </FormControl>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>{" "}
                    {LOCALE.no_trainings_added}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled || loadingTrainingData}
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            variant="outlined"
            size="small"
            disabled={btnDisabled || loadingTrainingData}
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
      {props.evaluation && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled}
            onClick={() => evaluationNextStep(trainingData)}
          >
            {LOCALE.next}
          </Button>
        </div>
      )}
      {showCommentDialog && (
        <GradingCommentComponent
          item={commentItem}
          preview={props.status == "ADDITIONAL_DATA_REQUIRED" ? true : false}
          index={commentIndex}
          handleClose={(item, index) => closeCommentDialog(item, index)}
        />
      )}
    </div>
  );
}
